// webpack module bootstap technic

import('./bootstrap');

// do not make any changes here
